import { getters } from '@/modules/core/app/helpers/store';
import { PageRouteConfig } from '@/modules/core/app/helpers/PageRouteConfig';
import { Module } from '@/modules/core/app/constants/app.constants';

export class UserRouteConfig extends PageRouteConfig {
  /**
   * Any contextual permissions based on route
   * @returns {boolean}
   */
  canAccessRouteFromContext() {
    return getters.session.getUserSettings().hasPermissionToRead(Module.USER);
  }

  /**
   * @returns {boolean}
   * @protected
   */
  _isRouteProtected(to) {
    if (this._isCurrentUserPageSettings(to)) {
      return false;
    }
    return super._isRouteProtected(to);
  }

  /**
   * @returns {boolean}
   * @private
   */
  _isCurrentUserPageSettings(to) {
    return to.params.id === getters.session.getUserSettings().userId;
  }
}
